<kodit-page>
  <kodit-delovodni-dokument-table *ngIf="delovodnikDto" [delovodnikDto]="delovodnikDto"></kodit-delovodni-dokument-table>
</kodit-page>
